import React from 'react';
import { connect } from 'react-redux';
import AttendeeLogin from '../../AttendeeLogin';
import { LoginWidgetScreen } from '@bizzabo/attendee-auth-api';
import { getIsAuthenticated } from '../../../../hocs/withEmailLogin';

import {
    eventUniqueNameSelector,
    eventIdSelector,
    websiteTypeSelector,
} from '../../../../selectors/EventSelectors';
import { mainEventColorSelector } from '../../../../selectors/SiteConfSelectors';
import useFullScreenContainer from '../hooks/useFullscreenContainer';
import useLoadingState from '../hooks/useLoadingState';
import useEmbedModule from '../hooks/useEmbedModule';
import LoaderView from '../../LoaderView';
import { SELECTORS } from '../constants';

const PeopleProfileContainer = ({
    eventId,
    eventUniqueName,
    mainEventColor,
    websiteType,
    isAuthenticated
}) => {
    const isWhitelabel = websiteType === 'whitelabel';
    const { containerRef } = useFullScreenContainer({
        headerSelector: SELECTORS.HEADER,
        footerSelector: SELECTORS.FOOTER
    });
    const { isLoading } = useLoadingState(isWhitelabel);

    useEmbedModule({
        moduleName: 'PeopleProfile',
        eventId,
        eventUniqueName,
        containerRef,
        mainEventColor,
        isWhitelabel,
        enabled: isAuthenticated,
    });

    if (!isAuthenticated) {
        return (
            <AttendeeLogin
                screen={LoginWidgetScreen.login}
                redirectUrl={window.location.href}
                closable={false}
                isShownByDefault
            />
        );
    }

    return (
        <div ref={containerRef} className="people-profile-container">
            {isLoading && (
                <div className="people-profile-loader">
                    <LoaderView />
                </div>
            )}
        </div>
    );
};

export default connect(state => ({
    eventId: eventIdSelector(state),
    eventUniqueName: eventUniqueNameSelector(state),
    mainEventColor: mainEventColorSelector(state),
    websiteType: websiteTypeSelector(state),
    isAuthenticated: getIsAuthenticated(state),
}))(PeopleProfileContainer);
